import { create } from 'zustand'

export const useContactStore = create((set) => ({
  states: [],
  setStates: (countryId, newStates) => {
    set((state) => ({
      states: [ 
        ...state.states,
        {countryId: parseInt(countryId), states: newStates}
      ],
    }));
  },
}))